import {useBehavioralContext} from "../../../../contexts";
import {useState} from "preact/compat";

export const useWarehouseModal = () => {
    // Controls the modal loading state
    const [isLoading, setIsLoading] = useState(false);

    // Retrieves all the cart component data
    const {
        sidebarCartData,
        handleCart
    } = useBehavioralContext();

    // Handles the modal open state
    const handleIsOpen = (state) => {
        // Validation to do nothing when state is true
        if (state) {
            return;
        }

        // Closes the modal and opens the sidebar cart component
        handleCart("_", "_", {
            isOpen:                   true,
            isSameWarehouseModalOpen: false,
            url:                      "",
            modalBypass:              true
        })
    }

    // Handles the modal loading state
    const handleIsLoading = (state) => {
        setIsLoading(prevState => {
            return typeof state !== "undefined" ? state : prevState;
        })
    }

    return {
        isLoading,
        sidebarCartData,
        handleCart,
        handleIsOpen,
        handleIsLoading
    }
}
